import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { translations } from "../lib/i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("aqar_lang") || "ar");

  useEffect(() => {
    localStorage.setItem("aqar_lang", lang);
    const dir = translations[lang].dir;
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const value = useMemo(() => {
    const t = (key) => translations[lang][key] ?? key;
    return {
      lang,
      dir: translations[lang].dir,
      t,
      toggle: () => setLang((l) => (l === "ar" ? "en" : "ar")),
      setLang,
    };
  }, [lang]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LangProvider");
  return ctx;
}
